<template>
  <EditUserMobileNumberForm :user-mobile-number="userMobileNumber"
                            :user-mobile-numbers-count="userMobileNumbersCount"
                            @formSubmit="formSubmitted($event)"
                            @clickDestroy="clickDestroy($event)"
                            @clickResendCode="clickResendCode($event)"
                            @updateUserMobileNumber = "updateUserMobileNumber" />
</template>
<script>
import store from "./UserMobileNumberStore";
import EditUserMobileNumberForm from "./EditUserMobileNumberForm.vue";
import UserMobileNumberMixin from "./UserMobileNumberMixin";

const responseStore = {
  response: null
};

export default {
  name: "UserMobileNumberEdit",

  title () {
    return this.$t("user.editMobile") + ` - ${Dashboard.currentTenant.name}`;
  },

  components: {
    EditUserMobileNumberForm
  },

  mixins: [UserMobileNumberMixin],

  data: function () {
    return {
      userMobileNumber: null,
      userMobileNumbersCount: null,
      responseStore: responseStore
    };
  },

  beforeMount () {
    this.userMobileNumber = this.user.user_mobile_numbers.find(userMobileNumber => userMobileNumber.id == this.$route.params.id);
    this.userMobileNumbersCount = this.user.user_mobile_numbers.length;
  },

  mounted () {
    this.addBreadcrumb(this.userMobileNumber.mobile_number);
  },

  methods: {
    formSubmitted (e) {
      this.updateResource();
      e.preventDefault();
    },

    async updateResource () {
      let responseJSON =
        await store.verifyUserMobileNumber(this.user.id, this.userMobileNumber.id);

      if (responseJSON.success) {
        this.$router.push({
          name: "Edit User",
          params: {
            id: this.user.id
          }
        });
        this.notifySuccess(responseJSON.successMessage);
      } else {
        this.notifyErrors(responseJSON.errorMessages);
      }
    },

    async clickDestroy (e) {
      this.handleResponse(await store.delete(this.userMobileNumber.id));
    },

    clickResendCode (e) {
      this.resendVerificationCode();
      e.preventDefault();
    },

    async resendVerificationCode () {
      let responseJSON =
        await store.resendVerificationCode(this.user.id, this.userMobileNumber.id);

      if (responseJSON.success) {
        this.notifySuccess(responseJSON.successMessage);
      } else {
        this.notifyErrors(responseJSON.errorMessages);
      }
    },
    updateUserMobileNumber (userMobileNumber) {
      this.userMobileNumber.mobile_number = userMobileNumber.mobile_number;
    }
  }
};
</script>
